import type { ReactElement } from 'react';

import BpkText, {
  TEXT_COLORS,
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';
import classNames from 'classnames';

import Logo from './Logo';

import type { CommonFlightsInlineCreative } from '../commonFlightsInlineAdTypes';

import STYLES from './TicketBrand.module.scss';

type TicketBrandProps = {
  creative: CommonFlightsInlineCreative;
  withSpacing?: boolean;
  vertical: boolean;
  sponsoredBadgeMultiline?: boolean;
};

export const TicketBrand = ({
  creative,
  sponsoredBadgeMultiline = false,
  vertical,
  withSpacing = false,
}: TicketBrandProps): ReactElement => {
  const { message, title } = creative;
  return (
    <div className={classNames(STYLES.container, withSpacing ? STYLES.containerSpaced : null)}>
      <div
        className={classNames(
          STYLES.partnershipRow,
          sponsoredBadgeMultiline ? STYLES.sponsoredBadgeMultiline : null,
        )}
      >
        <Logo creative={creative} isInline={!vertical} />
      </div>
      <div className={vertical ? STYLES.verticalBody : STYLES.horizontalBody}>
        <BpkText textStyle={TEXT_STYLES.heading4} tagName="h3" className={STYLES.item}>
          {title}
        </BpkText>
        <BpkText textStyle={TEXT_STYLES.footnote} tagName="p" color={TEXT_COLORS.textSecondary}>
          {message}
        </BpkText>
      </div>
    </div>
  );
};
